import { Transition } from 'react-transition-group';
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const modalOverlayStyles = css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    z-index: auto;
`;

const modalContentStyles = css`
    position: relative;
    background-color: #ffffff;
    padding: 20px;
    max-width: 90vw;
    max-height: 90vh;
    overflow: auto;
    border-radius: 20px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
    opacity: 0;
    transform: translateY(-60px);
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    z-index: auto;
`;

const Modal = ({ show, closeModal, zIndex, children }) => {
  return (
    <Transition in={show} timeout={200} mountOnEnter unmountOnExit>
      {(state) => (
        <div
          css={modalOverlayStyles}
          style={{
            opacity: state === 'entered' ? 1 : 0,
            zIndex: state === 'entered' ? zIndex : 'auto'
          }}
          onClick={closeModal}>
          <div
            css={modalContentStyles}
            style={{
              opacity: state === 'entered' ? 1 : 0,
              transform: state === 'entered' ? 'translateY(0)' : 'translateY(-60px)',
              zIndex: state === 'entered' ? zIndex : 'auto'
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {/*<div className="flex justify-end">*/}
            <div className={'absolute right-[20px] z-[1]'}>
              <div onClick={closeModal} className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </div>
            </div>
            <div className={'relative z-[0]'}>{children}</div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default Modal;
